<template>
    <div
        v-tooltip="isActive ? 'Unsubscribe' : 'Subscribe'"
        class="contentActions__item contentAction"
        :aria-label="isActive ? 'Unsubscribe' : 'Subscribe'"
        @click="handleClick"
    >
        <i
            class="fa-bell fa-swap-opacity"
            :class="isActive ? 'fad' : 'fal'"
        />
    </div>
</template>

<script>
import EventBus from '../EventBus';

export default {
    name: 'SubscribeAction',
    props: {
        isSubscribed: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            isActive: false,
        };
    },
    mounted() {
        if (this.isSubscribed) {
            this.isActive = true;
        }

        EventBus.$on('resource-subscribe', () => {
            this.isActive = true;
        });

        EventBus.$on('resource-unsubscribe', () => {
            this.isActive = false;
        });
    },
    methods: {
        handleClick() {
            this.$modal.show('resource-subscribe');
        },
    },
};
</script>
